module.exports = __webpack_public_path__ + "static/media/zod.b927af52.svg";